import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = (props) => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const targetId = location.hash.replace('#', '');

            // 1. Keep checking for the element until it officially renders
            const checkElementExist = setInterval(() => {
                const element = document.getElementById(targetId);

                if (element) {
                    // 2. Element found! Scroll to it smoothly
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    // 3. Stop checking once scrolled
                    clearInterval(checkElementExist);
                }
            }, 50); // Checks every 50ms

            // 4. Safety cleanup: stop checking after 3 seconds if the element never shows up
            setTimeout(() => {
                clearInterval(checkElementExist);
            }, 3000);

        } else {
            // Default fallback if there's no hashtag path
            window.scrollTo(0, 0);
        }
    }, [location]);
    return props.children
};

export default ScrollToTop;